import { useState, useEffect } from "react";
import "../styles/challenge-theme-questions.css";
import Button from "../../../../ui/atoms/buttons/Button";
import NotFound from "../../../../ui/organisms/not-found/404";
import ChallengeThemeQuestionItem from "../../components/challenge-theme-question-item/ChallengeThemeQuestionItem";
//
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  capitalizeAll,
  slugify,
  isEmpty,
} from "../../../../core/utils/helpers";
import { onGetChallengeThemeQuestionsByChallengeThemeId } from "../../services/challengeTheme";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeThemeQuestions = () => {
  const { id, title_en, title_fr } = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [challengeThemeQuestionsData, setChallengeThemeQuestionsData] =
    useState({});
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const currentChallengeTheme = useSelector(
    (state) => state?.challengeState?.currentChallengeTheme,
  );

  const _current_challenge_theme_id = currentChallengeTheme?.id;
  const _current_challenge_theme_title_en = currentChallengeTheme?.title_en;
  const _current_challenge_theme_title_fr = currentChallengeTheme?.title_fr;

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const _localData = {
      challenge_theme_id: _current_challenge_theme_id,
      rows_per_page: rowsPerPage,
      current_page: currentPage,
    };

    onGetChallengeThemeQuestionsByChallengeThemeId(
      axiosPrivate,
      _localData,
      signal,
    ).then((response) => {
      const _data = response?.data;
      setChallengeThemeQuestionsData(_data);
    });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [rowsPerPage, currentPage]);

  return (
    <div className="challenge-theme-questions">
      <div className="challenge-theme-questions-head">
        <h1>⁉️ Challenge Theme Questions Management</h1>
        <div className="w-full mb-xs">
          <span>Challenge Theme :</span>
          <h3>
            {capitalizeAll(_current_challenge_theme_title_en)} /{" "}
            {capitalizeAll(_current_challenge_theme_title_fr)}
          </h3>
        </div>
        <div className="w-full d-flex justify-space-between align-center">
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"⬅️ Back to ..."}
            action={() => navigate(-1)}
          />
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"➕ Create Questions"}
            action={() =>
              navigate(
                `/admin/challenge/themes/${id}/${slugify(title_en)}/${slugify(
                  title_fr,
                )}/questions/create`,
              )
            }
          />
          <div className="w-fit-content">
            <div className="pagination">
              <div className="p-wrapper">
                <button
                  className={
                    challengeThemeQuestionsData?.result_complements
                      ?.current_page === 1
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() =>
                    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1))
                  }
                  disabled={
                    challengeThemeQuestionsData?.result_complements
                      ?.current_page === 1
                  }
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {challengeThemeQuestionsData?.result_complements?.total_pages}{" "}
                  pages.
                </span>
                <button
                  className={
                    challengeThemeQuestionsData?.result_complements
                      ?.current_page ===
                    challengeThemeQuestionsData?.result_complements?.total_pages
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() =>
                    setCurrentPage((prev) =>
                      prev <=
                      challengeThemeQuestionsData?.result_complements
                        ?.total_pages
                        ? prev + 1
                        : prev,
                    )
                  }
                  disabled={
                    challengeThemeQuestionsData?.result_complements
                      ?.current_page ===
                    challengeThemeQuestionsData?.result_complements?.total_pages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="challenge-theme-questions-body">
        {isEmpty(challengeThemeQuestionsData?.result) ? (
          <NotFound
            type={"data"}
            title={"No Challenge Theme found!"}
            text={"No Challenge Theme available yet."}
            isBoutton={false}
          />
        ) : (
          challengeThemeQuestionsData?.result?.map((question, idx) => {
            return (
              <div className="w-50" key={idx}>
                <ChallengeThemeQuestionItem
                  index={idx + 1}
                  question_data={question}
                  isActionsButton={true}
                  isDisplayLanguage={true}
                  isCheckBox={false}
                  isRemoveButton={false}
                />
              </div>
            );
          })
        )}
        {/* <div className="w-50">
          <ChallengeThemeQuestionItem
            index={1}
            language={"fr"}
            question_data={""}
          />
        </div>
        <div className="w-50">
          <ChallengeThemeQuestionItem
            index={2}
            language={"en"}
            question_data={""}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ChallengeThemeQuestions;
